import { AIMagic, RightArrow } from "@monsterindia/global-ui-components";
import React from "react";

interface PrepAIViewProps {
  data: any;
  isMobile: boolean;
}

const PrepAIView: React.FC<PrepAIViewProps> = ({ data, isMobile }) => {
  return (
    <div className={`pb-6 md:!px-6 md:!pb-[0px] md:!pt-4`}>
      <div className="md:bg-warning-subtle flex w-auto flex-col gap-[10px] rounded-lg border border-[#E8E8EB] p-4 md:!max-w-[481px] md:flex-row md:justify-between md:rounded-l-md md:rounded-r-md md:!border-0 md:!p-0">
        <div className="text-content-primary flex items-center justify-start gap-2 p-0 text-[16px] font-bold leading-6 md:!justify-center md:!py-[12px] md:!pl-[16px] md:pr-[20px] md:!text-[14px] md:!font-medium md:!leading-[20px]">
          <p>Prep for your upcoming interview</p>
        </div>
        {isMobile ? (
          <div className="flex flex-col gap-4">
            <div>
              <p className="text-[10px] font-normal leading-[14px] tracking-[0.4px] text-[#E119A0]">
                [Company] interviewer
              </p>
              <p className="text-content-primary text-[14px] font-medium leading-[20px]">
                Q. {data.questions?.[0].question}
              </p>
            </div>
            <div>
              <p className="text-[10px] font-normal leading-[14px] tracking-[0.4px] text-[#E119A0]">
                Your personalised answer
              </p>
              <p className="text-content-primary text-[14px] font-normal leading-[20px]">
                A.{" "}
                {data.questions?.[0].answer
                  .split(" ")
                  .filter((data: any, index: number) => index < 10)
                  .join(" ")}{" "}
                <a
                  className="text-[#6E00BE]"
                  target="_blank"
                  rel="noreferrer"
                  href="/career-services/prep-ai?utm_source=applicationconfirm&utm_medium=platform&utm_term=JobApplication&utm_content=viewMoreQuestions&jobId=33662621"
                >
                  Read more
                </a>
              </p>
            </div>
          </div>
        ) : null}
        <a
          href="/career-services/prep-ai?utm_source=applicationconfirm&utm_medium=platform&utm_term=JobApplication&utm_content=viewMoreQuestions&jobId=33662621"
          target="_blank"
          rel="noreferrer"
          className="bg-cta-gradient mt-[6px] flex items-center justify-center gap-[4px] rounded-md px-4 py-3 text-[14px] font-semibold leading-[20px] text-white md:!mt-0 md:!px-[16px] md:!py-[12px]"
        >
          {isMobile ? (
            <>
              <p>View Personalised Q&A’s</p>
              <RightArrow width={16} height={16} fill="#FFFFFF" />
            </>
          ) : (
            <>
              <AIMagic width={16} height={16} fill="#FFFFFF" />
              <p>View Personalised Q&A’s</p>
            </>
          )}
        </a>
      </div>
    </div>
  );
};

export default React.memo(PrepAIView);
